import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import RequireAuth from './RequireAuth';

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));

// render - color
const Color = Loadable(lazy(() => import('pages/component-overview/color')));
const Typography = Loadable(lazy(() => import('pages/component-overview/typography')));
const Shadow = Loadable(lazy(() => import('pages/component-overview/shadows')));

// render - sample page
const SamplePage = Loadable(lazy(() => import('pages/extra-pages/sample-page')));
const ClientsPage = Loadable(lazy(() => import('pages/extra-pages/clients')));
const GrnsPage = Loadable(lazy(() => import('pages/extra-pages/grns')));
const MrnsPage = Loadable(lazy(() => import('pages/extra-pages/mrns')));
const IrfsPage = Loadable(lazy(() => import('pages/extra-pages/irfs')));
const LposPage = Loadable(lazy(() => import('pages/extra-pages/lpos')));
const FposPage = Loadable(lazy(() => import('pages/extra-pages/fpos')));
const ImprestsPage = Loadable(lazy(() => import('pages/extra-pages/imprests')));
const IcrsPage = Loadable(lazy(() => import('pages/extra-pages/icrs')));
const SalesPage = Loadable(lazy(() => import('pages/extra-pages/sales')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  children: [
    {
      path: 'dashboard',
      element: <RequireAuth />,
      children: [
        {
          element: <DashboardLayout />,
          children: [
            {
              index: true,
              element: <DashboardDefault />
            },
            {
              path: 'default',
              element: <DashboardDefault />
            },
            {
              path: 'clients',
              element: <ClientsPage />
            },
            {
              path: 'grns',
              element: <GrnsPage />
            },
            {
              path: 'mrns',
              element: <MrnsPage />
            },
            {
              path: 'irfs',
              element: <IrfsPage />
            },
            {
              path: 'lpos',
              element: <LposPage />
            },
            {
              path: 'fpos',
              element: <FposPage />
            },
            {
              path: 'cash-requisition',
              element: <IcrsPage />
            },
            {
              path: 'icrs',
              element: <IcrsPage />
            },
            {
              path: 'imprests',
              element: <ImprestsPage />
            },
            {
              path: 'sales',
              element: <SalesPage />
            },
          ]
        }
      ]
    },
    
  ]
};

export default MainRoutes;
